export default "__VITE_ASSET__DXSDYwqZ__"